/* eslint-disable no-lone-blocks */
import MainServices from "./Main.services";
import getState, { createPromise, formatNumber, generateGUID } from "../utils/MainHelper.js";
import { getCountryCode, getModuleCode, getOICode, getTreeFilter } from "../utils/oneintelligence/OneIntelligenceHelper";
import ConfigServices from "./Config.services";
import WorkerServices from "./Worker.services";
class TreeServices {
    constructor() {
        this.treeInitialPath = "$country/TREND/GOOGLE/$market_package/$tree_type/";
        this.treeInitialPathForVariant = "TREND\\GOOGLE\\$country\\$market_package\\$tree_type";

        this.moduleTreeConfig = {
            "gdn": {
                "Behaviors_Attributes.folder": {
                    folderTypeOverwrite: "TikTok Audiences"
                }
            },
            "hcp_attributes": {
                "Behaviors_Attributes.folder": {
                    folderTypeOverwrite: "HCP Insights"
                }
            },
            "expertmedia": {
                "Behaviors_Attributes.folder": {
                    folderTypeOverwrite: "HCP Insights"
                }
            },
            "patientattributes": {
                "Behaviors_Attributes.folder": {
                    folderTypeOverwrite: "Patient Insights"
                }
            }
        }
    }

    getTreeSpecificPath(params, toReplaceWords, specific = "marketpackage") {
        const {
            configuration: {
                selectedTarget
            }
        } = getState("marketExplorer");
        const {
            country, marketPackage, folderType, mpModule, pathOverwrite
        } = params;
        const { treeInitialPath } = this;
        let path = "";
        if (pathOverwrite) {
            path = treeInitialPath.split("$market_package")[0].replace("$country", country) + pathOverwrite
        } else {
            path = `${treeInitialPath.replace("$country", country)
                .replace("$market_package", marketPackage).replace("$tree_type", folderType)}`;

            if (["module", "usergroup", "user"].includes(specific)) {
                const { username } = MainServices.userDetails()
                const account = MainServices.getAccount()
                const usergroupname = MainServices.getUserGroup()
                const [userName] = username.split("@");

                if (mpModule) {
                    if (specific === "user") {
                        path += `${mpModule}/${account}/${usergroupname}/${userName}/treeFullNoPath.json`;
                    } else if (specific === "usergroup") {
                        path += `${mpModule}/${account}/${usergroupname}/treeFullNoPath.json`;

                    } else {
                        path += `${mpModule}/treeFullNoPath.json`;
                    }
                } else {
                    if (specific === "user") {
                        path += `${account}/${usergroupname}/${userName}/treeFullNoPath.json`;
                    } else if (specific === "usergroup") {
                        path += `${account}/${usergroupname}/treeFullNoPath.json`;

                    } else {
                        path += `treeFullNoPath.json`;
                    }
                }
            } else {
                path += "treeFullNoPath.json";
            }

        }

        return MainServices.getFile(path, "tree").then(async (resp) => {
            if (resp?.children) {
                let variants = null;
                if (["wp_brands",
                    "wp_generics",
                    "wp_hcps",
                    "wp_medications"].includes(selectedTarget?.code)
                    || folderType.includes("Generics.folder")) {
                    variants = await this.getVariantS3Cached(path, folderType);
                }
                return WorkerServices.setTreeLocalCached([params, resp.children, true, variants, toReplaceWords]).then((treeData) => treeData);
            }
            return resp;
        });
    }

    getSpecificFolder(params, toReplaceWords) {
        const {
            configuration: {
                selectedTarget
            }
        } = getState("marketExplorer");
        const {
            country, marketPackage, folderType, mpModule, pathOverwrite
        } = params;
        const { treeInitialPath } = this;
        let path = "";
        if (pathOverwrite) {
            path = treeInitialPath.split("$market_package")[0].replace("$country", country) + pathOverwrite
        } else {
            path = `${treeInitialPath.replace("$country", country)
                .replace("$market_package", marketPackage).replace("$tree_type", folderType)}`;
            if (mpModule) {
                path += `${mpModule}/treeFullNoPath.json`;
            } else {
                path += "treeFullNoPath.json";
            }
        }

        return MainServices.getFile(path, "tree").then(async (resp) => {
            if (resp.children) {
                let variants = null;
                if (["wp_brands",
                    "wp_generics",
                    "wp_hcps",
                    "wp_medications"].includes(selectedTarget?.code)
                    || folderType.includes("Generics.folder")) {
                    variants = await this.getVariantS3Cached(path, folderType);
                }
                return WorkerServices.setTreeLocalCached([params, resp.children, true, variants, toReplaceWords]).then((treeData) => treeData);
            }
            return resp;
        });
    }

    getMainFolder(params, toReplaceWords) {
        const {
            configuration: {
                selectedTarget
            }
        } = getState("marketExplorer");

        const {
            country, marketPackage, folderType, pathOverwrite
        } = params;
        const { treeInitialPath } = this;

        let path = ""
        if (pathOverwrite) {
            path = treeInitialPath.split("$market_package")[0].replace("$country", country) + pathOverwrite
        } else {
            path = `${treeInitialPath.replace("$country", country)
                .replace("$market_package", marketPackage).replace("$tree_type", folderType)}treeFullNoPath.json`;
        }
        return MainServices.getFile(path, "tree").then(async (resp) => {
            if (resp.children) {
                let variants = null;

                if (["wp_brands",
                    "wp_generics",
                    "wp_hcps",
                    "wp_medications"].includes(selectedTarget?.code)
                    || folderType.includes("Generics.folder")) {
                    variants = await this.getVariantS3Cached(path, folderType);
                }
                return WorkerServices.setTreeLocalCached([params, resp.children, false, variants, toReplaceWords]).then((treeData) => treeData);
            }
            return resp;
        });
    }

    getTreeData(notCheckable, folderTree, toReplaceWords, overwriteObj, selectedObj) {
        const {
            marketPackageOverwrite,
            folderTypeOverwrite,
            pathOverwrite
        } = overwriteObj || {};
        const {
            marketPackage
        } = getState("buildTargets").setup;

        const {
            code,
            title,
            name,
            parent: {
                oiCode,
                folder
            },
            folder: subFolder
        } = marketPackage

        if (!folder) {
            alert("Market Package Folder is not set in the application.");
            return Promise.resolve([]);
        }
        const enterpriseCode = getCountryCode("enterprise");
        if (!enterpriseCode) {
            alert("Country code is not set in this country.");
            return Promise.resolve([]);
        }
        const { promise, resolve } = createPromise();
        const params = {
            country: enterpriseCode,
            marketPackage: marketPackageOverwrite || subFolder || folder,
            folderType: folderTree,
            mpModule: ["whitespaces"].includes(oiCode) ? undefined : folderTypeOverwrite || title || name,
            notCheckable,
            mpCode: code,
            pathOverwrite
        };
        WorkerServices.getTreeLocalCached(params).then(async (respTreeData) => {
            if (respTreeData) resolve(respTreeData);
            else {
                // this.getSpecificFolder(params, toReplaceWords).then(async (resp) => {
                //     if (resp?.noData) {
                //         await this.getMainFolder(params, toReplaceWords);
                //     }
                //     WorkerServices.getTreeLocalCached(params).then((respTreeData2) => {
                //         if (respTreeData2) resolve(respTreeData2);
                //         else resolve([]);
                //     });
                // });
                const hasTreeFilter = await getTreeFilter(selectedObj);
                if (hasTreeFilter && hasTreeFilter[enterpriseCode]) {
                    this.getTreeSpecificPath(params, toReplaceWords, "module").then(async (resp) => {
                        if (!resp) {
                            await this.getTreeSpecificPath(params, toReplaceWords);
                        }
                        WorkerServices.getTreeLocalCached(params).then((respTreeData2) => {
                            if (respTreeData2) resolve(respTreeData2);
                            else resolve([]);
                        });
                    });
                } else {
                    this.getTreeSpecificPath(params, toReplaceWords, "user").then(async (resp) => {
                        if (!resp) {
                            const ugResp = await this.getTreeSpecificPath(params, toReplaceWords, "usergroup");
                            if (!ugResp) {
                                const modResp = await this.getTreeSpecificPath(params, toReplaceWords, "module");
                                if (!modResp) {
                                    await this.getTreeSpecificPath(params, toReplaceWords);
                                }
                            }
                        }
                        WorkerServices.getTreeLocalCached(params).then((respTreeData2) => {
                            if (respTreeData2) resolve(respTreeData2);
                            else resolve([]);
                        });
                    });
                }

            }
        });

        return promise;
    }

    getBehavioralAttributesFromOutSide(marketPackageOverwrite, folderTypeOverwrite, notCheckable) {
        const {
            configuration: {
                selectedTarget
            }
        } = getState("marketExplorer")

        return this.getTreeData(notCheckable, "Behaviors_Attributes.folder", undefined, {
            marketPackageOverwrite,
            folderTypeOverwrite
        }, selectedTarget);
    }
    getMyOwnKnowledgeBaseTree(selected, percentageCallBack = () => { }) {
        const { signedUsergroup: { usergroupName } } = MainServices.userDetails();

        const { configuration: { buildedTargets } } = getState("marketExplorer");

        const moduleCode = getModuleCode();
        const OICode = getOICode()
        let package_name = "Consumer"

        if (OICode === "pharma" || ["healthcarewhitespaces", "veterinaryjourney"].includes(moduleCode)) {
            package_name = "Healthcare"
        }

        const country = getCountryCode("enterprise");
        let otherParams = {};
        if (moduleCode === "whitespacesmodule") {
            let currentDate = new Date();
            otherParams = {
                fromdate: "2024-04-11",
                todate: currentDate.toISOString().split('T')[0]
            }
        }

        const objForCacheID = {
            selected: { ...selected },
            moduleCode,
            country,
            brandList: ConfigServices.brandListToFilter
        }
        delete objForCacheID?.selected?.bahavior
        delete objForCacheID?.selected?.targets

        percentageCallBack(1);
        return new Promise(async (resolve, reject) => {
            const cacheID = await WorkerServices.getObjectID([objForCacheID]);

            const { hasCache, cacheData } = await WorkerServices.checkMOKBCache([cacheID]);
            if (hasCache) resolve(cacheData)
            else {
                const path = `${country}/TREND/GOOGLE/MOKB/${package_name}/${usergroupName.split("~")[0]}/treeFullNoPath.json`;
                const mokbJSON = await MainServices.getFile(path, "tree")

                let promiseMOKB = null;
                if (mokbJSON && mokbJSON?.children?.length) {
                    promiseMOKB = WorkerServices.getMOKBTreeJSON({
                        selected,
                        moduleCode,
                        country,
                        response: mokbJSON,
                        buildedTargets,
                        brandList: ConfigServices.brandListToFilter
                    })
                } else {
                    promiseMOKB = new Promise(async (mokbResolve) => {
                        try {
                            let tempList = []
                            const getMOKBList = async (page) => {
                                const requestObj = {
                                    "username": "",
                                    "usergroup": usergroupName.split("~")[0],
                                    "account": "",
                                    "country_code": getCountryCode("enterprise"),
                                    "category": "",
                                    "subcategory": "",
                                    "path": "",
                                    "id": "",
                                    "withstructure": false,
                                    "recordsPerPage": OICode === "pharma" ? 500 : 1000,
                                    "page": page,
                                    "packagename": package_name,
                                    ...otherParams
                                }
                                const promise = MainServices.post("https://api.sqreem-api.com/oneknowledgev2/api/GetKeywordList", requestObj)
                                const response = await promise;

                                const { totalpage, data } = response?.data || {}
                                tempList = (tempList || []).concat(data);

                                let totalItems = totalpage;
                                let currentItems = page;
                                let percentage = (currentItems / totalItems) * 100;

                                percentageCallBack(parseFloat(formatNumber(percentage, 2)));
                                if (totalpage === page || !data.length) {
                                    mokbResolve(tempList);
                                } else {
                                    getMOKBList(page + 1);
                                }
                            };
                            getMOKBList(1);
                        } catch (error) {
                            mokbResolve([]);
                        }
                    }).then((response) => {
                        return WorkerServices.getMOKBTree({
                            selected,
                            moduleCode,
                            country,
                            response,
                            buildedTargets,
                            brandList: ConfigServices.brandListToFilter
                        })
                    })
                }
                promiseMOKB.then((response) => {
                    if (response.length)
                        return WorkerServices.setMOKBCache([cacheID, response])
                    return response
                }).then((response) => resolve(response))
            }
        }).then((data) => {
            percentageCallBack(0);
            return data;
        });
    }

    getBehavioralAttributes(notCheckable, selected, percentageCallBack) {
        const treeType = "Behaviors_Attributes.folder";
        const moduleCode = getModuleCode();
        if (["mokb_marketexplorer", "mokb_marketexplorer_main"].includes(selected?.code)) {
            return this.getMyOwnKnowledgeBaseTree(selected, percentageCallBack);
        }
        let objOverwrite = undefined;
        if (this.moduleTreeConfig[moduleCode]) {
            objOverwrite = this.moduleTreeConfig[moduleCode][treeType]
        }
        const {
            configuration: {
                selectedTarget
            },
        } = getState("marketExplorer")

        return this.getTreeData(notCheckable, treeType, undefined, {
            folderTypeOverwrite: selected?.folder,
            ...objOverwrite,
            ...(selected?.overwriteObj?.[moduleCode] || {})
        }, selectedTarget);
    }

    getAudienceTree(notCheckable, analysisObj, percentageCallBack) {
        const moduleCode = getModuleCode();

        if (analysisObj.key === "mokb_analysis") {
            return this.getMyOwnKnowledgeBaseTree(analysisObj, percentageCallBack);
        }
        let objOverwrite = {};
        if (analysisObj?.treeFolderObj) {
            if (analysisObj?.treeFolderObj?.[moduleCode] !== undefined) {
                objOverwrite.folderTypeOverwrite = analysisObj?.treeFolderObj?.[moduleCode]
                objOverwrite.pathOverwrite = ""
            }
        }

        let folder = analysisObj?.folder || "Audience Tree.folder";
        if (analysisObj?.folderObj) {
            const obj = analysisObj?.folderObj;
            if (obj[moduleCode]) {
                folder = obj[moduleCode];
            }
        }
        return this.getTreeData(notCheckable, folder, undefined, {
            pathOverwrite: analysisObj?.outsidePath,
            folderTypeOverwrite: analysisObj?.folder,
            ...objOverwrite,
            ...(analysisObj?.overwriteObj?.all || analysisObj?.overwriteObj?.[moduleCode] || {})
        }, analysisObj).then((rsp) => {
            return rsp
        })
    }

    getWhiteSpaceTree(notCheckable, selectedTarget, percentageCallBack) {
        const state = getState();

        if (["mokb_marketexplorer", "mokb_marketexplorer_main"].includes(selectedTarget?.code) || selectedTarget.key === "mokb_analysis") {
            return this.getMyOwnKnowledgeBaseTree(selectedTarget, percentageCallBack);
        }

        const {
            marketPackage
        } = state.buildTargets.setup;
        let replaceWords = {};
        if (selectedTarget?.folder?.includes("Generics.folder")) {
            replaceWords = {
                Generics: ""
            };
        }
        let folder = selectedTarget?.folder;
        if (selectedTarget?.folderObj) {
            const obj = selectedTarget?.folderObj;
            if (obj[marketPackage?.code?.replace("dev", "")]) {
                folder = obj[marketPackage?.code?.replace("dev", "")];
            }
        }
        return this.getTreeData(notCheckable, folder, replaceWords, undefined, selectedTarget).then((resp) => {
            console.log(resp);
            return resp
        })
    }

    getTreePath(folderType = "Audience Tree.folder", forVariant = false) {
        const { treeInitialPath, treeInitialPathForVariant } = this;
        const OICode = getOICode()
        const {
            marketPackage: {
                title,
                name,
                parent: {
                    folder: folderName
                },
                folder: subFolderName
            }
        } = getState("buildTargets").setup;

        try {
            const country = getCountryCode("enterprise");
            const marketPackage = subFolderName || folderName;
            if (!forVariant) {
                return `${treeInitialPath.replace("$country", country)
                    .replace("$market_package", marketPackage).replace("$tree_type", folderType)}`.slice(0, -1);
            }
            if (forVariant) {
                let newmp = marketPackage;
                if (!marketPackage.includes(".folder")) newmp += ".folder";
                let newft = folderType;
                if (!newft.includes(".folder")) newft += ".folder";
                else if (newft.includes("/")) newft += ".folder";
                let path = `${treeInitialPathForVariant.replace("$country", country).replace("$market_package", newmp).replace("$tree_type", newft)}`;
                const mpModule = ["whitespaces"].includes(OICode) ? undefined : title || name;
                if (mpModule) {
                    let newm = mpModule;
                    if (!newm.includes(".folder")) newm += ".folder";
                    path += `/${newm}`;
                }
                return path;
            }
            return "";
        } catch (error) {
            return "";
        }
    }

    async getVariantS3Cached(path, folderType) {
        try {
            const variants = await MainServices.getKeywordDetails(this.getTreePath(folderType, true));
            // const uplodPath = path.replace("treeFullNoPath", "variants");
            // await MainServices.uploadFile(uplodPath, JSON.stringify(variants), "tree");
            return Promise.resolve(variants);
        } catch (error) {
            return Promise.resolve(null);;
        }
    }
}

export default new TreeServices()
